/** Accept only official HTTPS WhatsApp links, never arbitrary redirect schemes. */
export function normalizeWhatsAppLink(value: unknown): string {
  if (typeof value !== "string" || !value.trim()) return "";
  try {
    const url = new URL(value.trim());
    if (url.protocol !== "https:" || url.username || url.password || url.port) return "";
    if (!["wa.me", "api.whatsapp.com", "web.whatsapp.com", "www.whatsapp.com", "chat.whatsapp.com"].includes(url.hostname)) return "";
    if (url.pathname === "/") return "";
    return url.href;
  } catch { return ""; }
}
export function publicWhatsAppSettings(raw: any) {
  const link = normalizeWhatsAppLink(raw?.link);
  return { enabled: raw?.enabled === true && !!link, link };
}
